<template>
  <div class="guide-page">
    <div class="container">
      <h1 class="big-title my-5">Guide d'utilisation</h1>
    </div>
    <guide-section
    v-for="section in sections"
      @knowMoreClicked="openDialogSection(section)"
      :key="section.title"
      :iconName="section.iconName"
      :title="section.title"
      :description="section.description"
      :buttonClass="section.buttonClass"
      :horizontalPosition="section.horizontalPosition"
      :arrowConfig="section.arrowConfig"
      :withTopPadding="section.withTopPadding"
    />
      <Dialog 
        :header="this.currentDialogHeader" 
        :visible.sync="isDialogVisible" 
        :style="{width: '50vw'}"
        dismissableMask
        modal
        >
        <component :is="currentDialogContent" />
        </Dialog>
      <div class="blob bg-red" id="blob-red"/>
      <div class="blob bg-yellow" id="blob-yellow"/>
      <div class="blob blob-gigantic bg-blue" id="blob-blue"/>
      <div class="blob blob-gigantic bg-green" id="blob-green"/>
  </div>
</template>
<script>
import GuideSection from "../components/Guide/GuideSection.vue"
import ConnectionDialogContent  from "../components/Guide/ConnectionDialogContent.vue"
import ProfileDialogContent  from "../components/Guide/ProfileDialogContent.vue"
import DashboardDialogContent  from "../components/Guide/DashboardDialogContent.vue"
import InvitationsDialogContent  from "../components/Guide/InvitationsDialogContent.vue"
import ProjectDialogContent  from "../components/Guide/ProjectDialogContent.vue"
import TeachModeDialogContent  from "../components/Guide/TeachModeDialogContent.vue"
import CodeEditionDialogContent  from "../components/Guide/CodeEditionDialogContent.vue"

export default {
  components: {
    GuideSection,
    ConnectionDialogContent,
    ProfileDialogContent,
    DashboardDialogContent,
    InvitationsDialogContent,
    ProjectDialogContent,
    TeachModeDialogContent,
    CodeEditionDialogContent,
  },
  methods: {
    openDialogSection(section) {
      this.isDialogVisible = true
      this.currentDialogHeader = section.title
      this.currentDialogContent = section.DialogContent
    }
  },
  data() {
    return {
      isDialogVisible: false,
      currentDialogContent: null,
      currentDialogHeader: "Plus d'infos",
      sections: [
        {
          iconName:"mdi-login-variant",
          title:"Inscription et connexion",
          description:"Pour vous connecter à CodeSnippet, rien de plus simple : rendez-vous sur la page de connexion et entrez votre adresse mail ou nom d’utilisateur ainsi que votre mot de passe. Si vous ne disposez pas encore de compte, vous pouvez également vous inscrire gratuitement.",
          buttonClass:"bg-purple",
          horizontalPosition:"center",
          DialogContent: "ConnectionDialogContent",
          arrowConfig: {
            color: 'blue',
            topPosition: 19,
            leftPosition: 38,
          },
        },
            {
          iconName:"mdi-account-circle",
          title:"Mon profil",
          description:"Une fois connecté, vous avez la possibilité de modifier toutes les informations associées à votre profil : pseudonyme, mot de passe, adresse mail. Vous pouvez également supprimer votre compte, ce qui supprimera également tous les projets que vous avez créés.",
          buttonClass:"bg-purple",
          horizontalPosition:"right",
          DialogContent: "ProfileDialogContent",
          arrowConfig: {
            color: 'red',
            topPosition: 19,
            leftPosition: 12,
            isPointingLeft: true,
          }
        },
            {
          iconName:"mdi-view-dashboard",
          title:"Dashboard",
          description:"Pour retrouver tous les projets que vous avez créés ou auxquels vous participez, vous pouvez vous rendre sur le tableau de bord (dashboard). Des outils de recherche vous permettent d’identifier rapidement les projets par type, titre ou bien par leur date de dernière modification !",
          buttonClass:"bg-purple",
          horizontalPosition:"center",
          DialogContent: "DashboardDialogContent",
          arrowConfig: {
            color: 'yellow',
            topPosition: 22,
            leftPosition: 0,
            isPointingLeft: true,
          }
        },
            {
          iconName:"mdi-lightbulb-on",
          title:"Les projets",
          description:"Il y a deux principaux types de projet : les projets d’équipe, où tous les participants peuvent écrire du code librement, et les projets d’enseignement qui permettent à un enseignant de guider ses élèves avec un exemple de code, un modèle. Il peut également définir un mode examen qui permet de limiter l'accès au projet dans le temps.",
          buttonClass:"bg-purple",
          horizontalPosition:"left",
          DialogContent: "ProjectDialogContent",
          arrowConfig: {
            color: 'black',
            topPosition: 26,
            leftPosition: 8,
            isPointingLeft: true,
          }
        },
            {
          iconName:"mdi-code-tags",
          title:"Édition de code",
          description:"Dans chaque projet, vous pouvez écrire du code HTML, CSS et JavaScript. En fonction du type de projet, vous pourrez éditer le code en simultané avec les autres participants et voir le résultat de votre travail en direct avec l’outil de prévisualisation.",
          buttonClass:"bg-purple",
          horizontalPosition:"left",
          withTopPadding: true,
          DialogContent: "CodeEditionDialogContent",
          arrowConfig: {
            color: 'purple',
            topPosition: 27,
            leftPosition: 16,
          }
        },
            {
          iconName:"mdi-school",
          title:"Mode enseignant",
          description:"En tant qu’enseignant, vous pouvez créer un projet adapté à vos besoins et à vos étudiants grâce à CodeSnippet. Dans un projet enseignant, vous pouvez définir une date d’édition limite, répartir les participants en sous-groupes, limiter l’accès à la visualisation et consulter leur travail en direct.",
          buttonClass:"bg-purple",
          horizontalPosition:"center",
          DialogContent: "TeachModeDialogContent",
          withTopPadding: true,
          arrowConfig: {
            color: 'green',
            topPosition: 21,
            leftPosition: 40,
          }
        },
            {
          iconName:"mdi-email",
          title:"Invitations",
          description:"Pour accéder à n’importe quel projet CodeSnippet, il faut être connecté et donc avoir un compte. Lorsque vous créez un projet, vous n’avez cependant pas besoin d’attendre que tous les utilisateurs se soient inscrits. Il vous suffit de les ajouter par mail et on se charge de les inviter à rejoindre l’application et votre projet !",
          buttonClass:"bg-purple",
          horizontalPosition:"right",
          DialogContent: "InvitationsDialogContent",
        }
      ]
    }
  }
}
</script>